import React, { useState, useEffect, useCallback } from 'react'
import {
  FileBrowser,
  FileNavbar,
  FileToolbar,
  FileList,
  FileContextMenu,
  ChonkyActions,
  setChonkyDefaults
} from 'chonky'
import { ChonkyIconFA } from 'chonky-icon-fontawesome';

import { Auth } from 'aws-amplify';
import AWS from 'aws-sdk'

import path from 'path'
import moment from 'moment'

import { Lightbox } from 'react-modal-image'

import { CreateFolderForm, UploadForm } from './index'

setChonkyDefaults({
  iconComponent: ChonkyIconFA,
});

const REGION_NAME = 'ap-northeast-1'
const BUCKET_NAME = 'bc-robop'

const S3Browser = (props) => {

  const [credentials, setCredentials] = useState(null)

  const [files, setFiles] = useState([])
  const [folderPrefix, setKeyPrefix] = useState('/')
  const [folderChain, setFolderChain] = useState([{ id: '/', name: BUCKET_NAME, isDir: true, }])

  const [urlToHugeImageFile, setPreviewImageUrl] = useState('')

  const [isPreview, setPreview] = useState(false)
  const handleClosePreview = useCallback(() => {
    setPreview(false)
  }, [setPreview])

  const [isOpenUploadForm, setOpenUploadForm] = useState(false)
  const handleCloseUploadForm = useCallback(() => {
    setOpenUploadForm(false)
  }, [setOpenUploadForm])

  const [isOpenCreateFolderForm, setOpenCreateFolderForm] = useState(false)
  const handleCloseCreateFolderForm = useCallback(() => {
    setOpenCreateFolderForm(false)
  }, [setOpenCreateFolderForm])

  const fetchBucket = useCallback(() => {
    let params = {
      Bucket: BUCKET_NAME,
      Delimiter: '/',
      Prefix: folderPrefix !== '/' ? folderPrefix : ''
    }

    if (credentials === null) return []

    const s3 = new AWS.S3({
      credentials: credentials,
      region: REGION_NAME,
    });

    s3.listObjectsV2(params)
      .promise()
      .then((res) => {
        console.debug('Response', res)

        const chonkyFiles = []
        const s3Objects = res.Contents
        const s3Prefixes = res.CommonPrefixes

        if (s3Objects) {
          chonkyFiles.push(
            ...s3Objects.map((content, index) => ({
              id: content.Key,
              name: path.basename(content.Key),
              modDate: content.LastModified,
              size: content.Size,
              isDir: false,
              // thumbnailUrl: 'https://' + BUCKET_NAME + '.s3.ap-northeast-1.amazonaws.com/' + content.Key
            }))
          ) 
        }

        // do not show ".(current folder object)"
        // console.debug(chonkyFiles[chonkyFiles.findIndex(o => o.id === folderPrefix)])
        chonkyFiles.splice(chonkyFiles.findIndex(o => o.id === folderPrefix), 1)
        console.debug('List contents', chonkyFiles)

        if (s3Prefixes) {
          chonkyFiles.push(
            ...s3Prefixes.map((prefix, index) => ({
              id: prefix.Prefix,
              name: path.basename(prefix.Prefix),
              isDir: true
            }))
          )
        }

        console.debug('chonkyfiles', chonkyFiles)
        // return chonkyFiles
        setFiles(chonkyFiles)
      })
      .catch((err) => {
        console.error(err.message)
      })

  }, [credentials, folderPrefix])

  const putToBucket = (param) => {
    if (credentials === null) return

    const s3 = new AWS.S3({
      credentials: credentials,
      region: REGION_NAME,
    })

    s3.putObject(param)
      .promise()
      .then((res) => {
        console.log(res)
        fetchBucket()
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const deleteFromBucket = (param) => {
    if (credentials === null) return

    const s3 = new AWS.S3({
      credentials: credentials,
      region: REGION_NAME,
    })

    s3.deleteObject(param)
      .promise()
      .then((res) => {
        console.log(res)
        fetchBucket()
      })
      .catch((err) => {
        console.error(err)
      })
  }


  //----------
  // Effect (component did mount)
  useEffect(() => {
    // Get current credentials
    (async () => {
      console.debug('Effect after rendering')
      console.debug('Get current credentials')

      const cre = await Auth.currentCredentials()
      if (cre === null) console.error('Could not get credentials')

      setCredentials(cre) //call useState hook
    })()

  }, [])
  //----------

  // Fetch effect
  useEffect(() => {
    if (credentials === null) return
    fetchBucket()
  }, [credentials, folderPrefix, fetchBucket])

  // Make 'folderChain' array
  useEffect(() => {
    if (credentials === null) return

    let fchain = []

    if (folderPrefix === '/') {
    }
    else {
      let currentPrefix = ''

      fchain = folderPrefix
        .replace(/\/*$/, '')
        .split('/')
        .map((prefixPart, index) => {
          currentPrefix = currentPrefix
            ? path.join(currentPrefix, prefixPart)
            : prefixPart

          return {
            id: currentPrefix,
            name: prefixPart,
            isDir: true
          }
        })
    }

    fchain.unshift(
      { id: '/', name: BUCKET_NAME, isDir: true }
    )

    console.debug('Make folderChain effect:', fchain)

    // console.log(fchain)
    setFolderChain(fchain)

  }, [credentials, folderPrefix])

  // ---
  // Handle Chonky Actions
  //
  const handleChonkyActions = useCallback((data) => {
    switch (data.id) {
      case ChonkyActions.OpenFiles.id:
        if (data.payload.files && data.payload.files.length !== 1) return
        if (!data.payload.targetFile) return

        if (data.payload.targetFile.isDir) {
          console.log('Folder chain:', folderChain)

          // const newPrefix = data.payload.targetFile.id === '/' ? '/' : data.payload.targetFile.id
          let newPrefix = `${data.payload.targetFile.id.replace(/\/*$/, '')}/`
          console.log('Key prefix:', newPrefix)

          setKeyPrefix(newPrefix)
        }
        else {
          setPreviewImageUrl(data.payload.targetFile.thumbnailUrl)
          setPreview(true)
          return
        }
        break;

      case ChonkyActions.CreateFolder.id:
        setOpenCreateFolderForm(true)
        break;

      case ChonkyActions.DeleteFiles.id:
        console.debug(data.state.selectedFiles)
        let selectedFiles = data.state.selectedFiles

        selectedFiles.map((file, index) => {
          let params = {
            Bucket: BUCKET_NAME,
            Key: file.id
          }

          deleteFromBucket(params)
        })
        break;

      case ChonkyActions.UploadFiles.id:
        setOpenUploadForm(true)
        break;

      default:
        break;
    }
  }, [])

  return (
    <div style={{ height: 700 }}>
      <FileBrowser //chonky file browser
        files={files}
        folderChain={folderChain}
        fileActions={[
          ChonkyActions.OpenFiles,
          ChonkyActions.UploadFiles,
          ChonkyActions.DownloadFiles,
          ChonkyActions.CreateFolder,
          ChonkyActions.DeleteFiles]}
        onFileAction={handleChonkyActions}>

        <FileNavbar></FileNavbar>
        <FileToolbar></FileToolbar>
        <FileList></FileList>
        <FileContextMenu></FileContextMenu>

      </FileBrowser>

      <UploadForm
        open={isOpenUploadForm}
        onClose={handleCloseUploadForm}
        onSave={(files) => {
          let folderDepth = folderChain.length
          let curFolderId = folderChain[folderDepth - 1].id
          let keyPrefix = curFolderId === '/'
            ? ''
            : curFolderId + '/'

          files.map((file, index) => {
            let params = {
              Bucket: BUCKET_NAME,
              Key: keyPrefix + file.name, //
              Body: file, //file object from material-ui/DropzoneDialog component
              ACL: 'public-read'
            }

            console.debug(params)
            putToBucket(params)

          })
        }}
      />

      {
        isPreview && <Lightbox
          large={urlToHugeImageFile}
          onClose={handleClosePreview}
          alt="Preview"
        />
      }

      <CreateFolderForm
        open={isOpenCreateFolderForm}
        onClose={handleCloseCreateFolderForm}
        onCreate={(folderName) => {

          // const folderName = place
          //   + '/'
          //   + moment(date).format('YYYY-MM-DD')

          let params = {
            Bucket: BUCKET_NAME,
            Key: (folderPrefix !== '/' ? folderPrefix : '')
              + folderName + '/'
          }

          putToBucket(params)

          handleCloseCreateFolderForm()

        }} />

    </div>
  )
}

export default S3Browser
